import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { InterviewReviewType } from '~types/review';

import QueryKeys from '../queryKeys';

export interface InterviewReviewItem {
  content: string;
  count: number;
}

export interface InterviewReviewObj {
  content: string;
  data: InterviewReviewItem[];
}

export interface InterviewReviewResponse {
  totalCount: number;
  defaultSource: InterviewReviewType;
  reviews: Record<InterviewReviewType, InterviewReviewObj>;
}

export interface InterviewReviewTabs {
  id: InterviewReviewType;
  content: string;
}

export default function useGetInterview(companyHash?: string) {
  return useQuery<InterviewReviewResponse>(
    [QueryKeys.companyReviewInterview, 'list', companyHash],
    () => fetcher(`/api/review/interview?PK_NM_HASH=${companyHash}`),
    { enabled: !!companyHash },
  );
}

export function useGetInterviewReviewTabs(companyHash?: string) {
  const { data, ...rest } = useGetInterview(companyHash);

  if (rest.status !== 'success' || !data) {
    return {
      data: undefined,
      ...rest,
    };
  }

  const keys = Object.keys(data?.reviews) as InterviewReviewType[];

  const tabs: InterviewReviewTabs[] = keys.map((key) => {
    return {
      id: key,
      content: data.reviews[key].content,
    };
  });

  return {
    ...rest,
    data: tabs,
  };
}
